export function formatDate(date) {  
  if (!date) return ''

  let [y, m, d] = date.split('-')

  y = y ? `${y * 1}年` : ''
  m = m ? `${m * 1}月` : ''
  d = d ? `${d * 1}日` : ''

  return `${y}${m}${d}`
}

export function formatDateWeekDay(date) {  
  if (!date) return ''

  let formattedDate = formatDate(date)
  let timezoneOffset = (new Date(date).getTimezoneOffset() + (9 * 60)) * 60 * 1000
  let jsDate = new Date(date).getTime() + timezoneOffset
  const weekDay = '日月火水木金土'[new Date(jsDate).getDay()]

  return formattedDate += `（${weekDay}）`
}

/**
 * @return yyyy月mm月dd日 hh:mm (mm(分)以外は前0無し)
 */
export function formatDateTime(date) {
  if (!date) return ''

  let timezoneOffset = (new Date(date.replace(/-/g,"/")).getTimezoneOffset() + (9 * 60)) * 60 * 1000
  let formatDate = new Date(new Date(date.replace(/-/g,"/")).getTime() + timezoneOffset)
  const year = formatDate.getFullYear()
  const month = formatDate.getMonth() + 1
  const day = formatDate.getDate()
  const hour = formatDate.getHours()
  const minutes = ('0' + formatDate.getMinutes()).slice(-2)

  return year + '年' + month + '月' + day + '日 ' + hour + ':' + minutes
}

/**
 * return yyyymmddhhmm(年月日時分)
 */
export function formatYmdhmsStr(date){
  if (!date) return ''

  const year = date.getFullYear()
  const month = ("00" + (date.getMonth()+1)).slice(-2)
  const day = ("00" + date.getDate()).slice(-2)
  const hour = ("00" + date.getHours()).slice(-2)
  const minite = ("00" + date.getMinutes()).slice(-2)

  return `${year}${month}${day}${hour}${minite}`
}
